var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSnapPack = function SvgSnapPack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 46 35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M3.177 7.03A2.64 2.64 0 0 1 2 4.831v-.002A2.83 2.83 0 0 1 4.829 2h36.797a2.83 2.83 0 0 1 2.829 2.829v.002c0 .884-.442 1.709-1.178 2.2l-18.48 12.32a2.83 2.83 0 0 1-3.14 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M2 4.83v25.473c0 .75.298 1.47.83 2.001.53.531 1.25.83 2 .83h36.794a2.827 2.827 0 0 0 2.83-2.831V4.83"
  })));
};
export default SvgSnapPack;